export const gridDataHandlingStrategies = {
  DEFAULT: 0,
  APPEND: 1,
};
